export const paths = {
  suggestion: "/suggestion",
  attachment: "/suggestion/attachment",
  score: "/score",
  data: "/data.json",
};
